<script>

import PriceList from '@/components/PriceListV1.vue';

export default {
  components: { PriceList },
  props: {
    value: {
      type: Object,
      default: () => ({
        type: 'none',
        custom: {},
      }),
    },
  },
  data() {
    return {
      type: 'none',
      customPrices: {},
    };
  },
  methods: {
    emitSettings() {
      const settings = {
        type: this.type,
        custom: this.customPrices,
      };
      console.debug('emitSettings', settings);
      this.$emit('input', settings);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.type = value.type;
        this.customPrices = value.custom;
      },
    },
    type() {
      this.emitSettings();
    },
    customPrices() {
      this.emitSettings();
    },
  },
};
</script>

<template>
  <div>
    <select v-model="type">
      <option value="none">отсутствует</option>
      <option value="pushhouse">учитывать мин. цены Push.house</option>
      <option value="custom">собственные лимиты</option>
    </select>
    <div v-if="type === 'custom'">
      <price-list v-model="customPrices" />
    </div>
  </div>
</template>

<style scoped>

</style>
